export default __webpack_public_path__ + "static/clpt-b9495b967877e65250b255730388ae4f.jpg";